import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import WarningTriangle from '../../../../public/assets/img/warning.svg';
import checkedIcon from '../../../../public/assets/img/checked.svg';
import unCheckedIcon from '../../../../public/assets/img/unchecked.svg';
import sevenNowLogo from '../../../../public/assets/img/seven-now-logo.svg';
import { TextField, CardContent, Card, InputAdornment, CircularProgress } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_PASSWORD, PRIVACY_POLICY_CONTENT, CREATE_PASSWORD, MERCHANT_PORTAL_TEXT } from '../../../constants/buttonConstants';
import { LOGIN_VERBIAGE, EMAIL_VERBIAGE, TEMP_PASSWORD_TEXT } from '../../../constants/landingConstant';
import './password.scss';
import { tempPasswordResponseSaga } from '../../../redux/saga/loginServiceSelector';
import { tempPasswordRequest } from '../../../redux/actions/loginServiceAction';
import { PASSWORD_CHAR, PASSWORD_MIN, PASSWORD_MSG, PASSWORD_REP, PASSWORD_NUMBER_REQ } from '../../../constants/settingsPageConstants';
import { checkForRepeatedSequence, onlySpecialCharaAllowed, restrictOnlyFewSpecialChara, containsAtleastOneNumber } from '../../../shared/utils/format.helpers';
import {encryptPassword} from '../../../shared/utils/common';

function TempPassword() {
  
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const tempPasswordResponse = useSelector(tempPasswordResponseSaga);
	const [confirmpasswordError, setconfirmpasswordError] = useState(false);
	const [passwordError, setPasswordError] = useState(false);
	const [formValid, setformValid] = useState(false);
	const [formData, setformData] = useState({
		fields: {
		password: '',
		confirmpassword: '',
		},
		errors: {},
	});
	const regExpSpecialChara = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
	const [confirmpasswordErrorIcon, setconfirmpasswordErrorIcon] = useState(null);
	const [passwordErrorIcon, setpasswordErrorIcon] = useState(false);
	const [miniCharaCheckIcon, setminiCharCheckIcon] = useState(unCheckedIcon);
	const [specialCharaCheckIcon, setspecialCharaCheckIcon] = useState(unCheckedIcon);
	const [containsNumberCheckIcon, setContainsNumberCheckIcon] = useState(unCheckedIcon);
	const [noRepCharaCheckIcon, setNoRepCharaCheckIcon] = useState(unCheckedIcon);
	const [apiInProgress, setapiInProgress] = useState(false);
	const [tokenValue, setTokenValue] = useState('');
	const [queryParameters] = useSearchParams();
	const [emailWord, setEmailWord] = React.useState('');

	useEffect(() => {
		let emailWordText = EMAIL_VERBIAGE;
		emailWordText = emailWordText
		.split(' ')
		.map((wd) => {
			if (wd === '[email]') {
			wd = process.env.REQUEST_ACCESS_MAIL;
			}
			return wd;
		})
		.join(' ');

		setEmailWord(emailWordText);

		if (queryParameters.get('token')) {
		// setTokenValue(queryParameters.get('token'));
		let tokenV = queryParameters.get('token');
		tokenV = tokenV.split(' ').join('+');
		setTokenValue(tokenV);
		// console.log('TOKEN ',tokenV, tokenV.length);
		}
	}, []);
  
	useEffect(() => {
		if (tempPasswordResponse) {
		if (tempPasswordResponse?.msg) {
			setapiInProgress(false);
			navigator('/update_password_failed');
		} else {
			setapiInProgress(false);
			navigator('/update_password_success');
		}
		}
	}, [tempPasswordResponse]);

	const confirmPasswordReset = (e) => {
		e.preventDefault();

		// const temporaryPassword = encryptPassword(formData.fields.temppassword);
		const password = encryptPassword(formData.fields.password);
		if (formValid) {
		setapiInProgress(true);
		dispatch(tempPasswordRequest(tokenValue, password));
		}
	};

	const handleChange = (e) => {
		let fields = formData.fields;
		let errors = formData.errors;
		fields[e.target.id] = e.target.value;

		// console.log('fsdf ',onlySpecialCharaAllowed(formData.fields.password),regExpSpecialChara.test(formData.fields.password))
		if (e.target.id === 'password') {
		if (formData.fields.password === '' || formData.fields.password.length < 14 || formData.fields.password.length > 20 || !restrictOnlyFewSpecialChara(formData.fields.password)) {
			setPasswordError(true);
			setpasswordErrorIcon(WarningTriangle);
			setminiCharCheckIcon(unCheckedIcon);
			containsAtleastOneNumber(formData.fields.password) === true ? setContainsNumberCheckIcon(checkedIcon) : setContainsNumberCheckIcon(unCheckedIcon);
			onlySpecialCharaAllowed(formData.fields.password) === true ? setspecialCharaCheckIcon(checkedIcon) : setspecialCharaCheckIcon(unCheckedIcon);

			checkForRepeatedSequence(formData.fields.password) ? setNoRepCharaCheckIcon(checkedIcon) : setNoRepCharaCheckIcon(unCheckedIcon);
			// (regExpSpecialChara.test(formData.fields.password) === true) ? setspecialCharaCheckIcon(checkedIcon) : setspecialCharaCheckIcon(unCheckedIcon);
			errors[e.target.id] = 'Enter a password';
		} else {
			onlySpecialCharaAllowed(formData.fields.password) === true ? setspecialCharaCheckIcon(checkedIcon) : setspecialCharaCheckIcon(unCheckedIcon);
			containsAtleastOneNumber(formData.fields.password) === true ? setContainsNumberCheckIcon(checkedIcon) : setContainsNumberCheckIcon(unCheckedIcon);

			checkForRepeatedSequence(formData.fields.password) ? setNoRepCharaCheckIcon(checkedIcon) : setNoRepCharaCheckIcon(unCheckedIcon);

			// (regExpSpecialChara.test(formData.fields.password) === true) ? setspecialCharaCheckIcon(checkedIcon) : setspecialCharaCheckIcon(unCheckedIcon);
			formData.fields.password.length >= 14 && formData.fields.password.length <= 20 ? setminiCharCheckIcon(checkedIcon) : setminiCharCheckIcon(unCheckedIcon);
			if (regExpSpecialChara.test(formData.fields.password) && formData.fields.password.length >= 14) {
			setPasswordError(false);
			setpasswordErrorIcon(null);
			delete errors[e.target.id];
			}
			if (formData.fields.password === formData.fields.confirmpassword) {
			setconfirmpasswordError(false);
			setconfirmpasswordErrorIcon(null);
			delete errors['confirmpassword'];
			} else {
			if (formData.fields.confirmpassword.length >= 14) {
				setconfirmpasswordErrorIcon(WarningTriangle);
				setconfirmpasswordError(true);
				errors['confirmpassword'] = 'Password do not match';
			}
			}
		}
		}

		if (e.target.id === 'confirmpassword' || (e.target.id === 'password' && formData.fields.confirmpassword !== '')) {
		if (formData.fields.confirmpassword === '' && formData.fields.confirmpassword.length <= 14) {
			setconfirmpasswordErrorIcon(WarningTriangle);
			setconfirmpasswordError(true);
			errors['confirmpassword'] = 'Enter confirm password';
		} else {
			if (formData.fields.password === formData.fields.confirmpassword) {
			setconfirmpasswordError(false);
			setconfirmpasswordErrorIcon(null);
			delete errors['confirmpassword'];
			} else {
			if (formData.fields.confirmpassword.length >= 14) {
				setconfirmpasswordErrorIcon(WarningTriangle);
				setconfirmpasswordError(true);
				errors['confirmpassword'] = 'Password do not match';
			}
			}
		}
		}
		setformData({ ...formData });
	};

	useEffect(() => {
		setformValid(
			formData.fields.password.length > 0 &&
			formData.fields.confirmpassword.length > 0 &&
			formData.fields.password === formData.fields.confirmpassword &&
			!passwordError &&
			!confirmpasswordError &&
			checkForRepeatedSequence(formData.fields.password) &&
			restrictOnlyFewSpecialChara(formData.fields.password) &&
			onlySpecialCharaAllowed(formData.fields.password) &&
			containsAtleastOneNumber(formData.fields.password)
		);
		// console.log('ERRORs ', passwordError, confirmpasswordError)
	}, [formData.fields.password, formData.fields.confirmpassword, passwordError, confirmpasswordError]);

	const userAccountList = (landingStyle) => {
		return (
		<div className={landingStyle ? 'content-leftPanel' : ''}>
			{landingStyle ? (
			<>
				<p>{LOGIN_VERBIAGE}</p>
			</>
			) : (
			''
			)}
			<p>{TEMP_PASSWORD_TEXT}</p>
		</div>
		);
	};

	const termsOfUseHandler = (e) => {
		window.open(process.env.TERMS_URL, '_blank');
		e.preventDefault();
	};

	const privacyPolicyHandler = (e) => {
		window.open(process.env.PRIVACY_URL, '_blank');
		e.preventDefault();
	};

	return (
		<>
		<Container fluid className='vh-100 d-flex flex-column ' data-testid='temp-pass-id'>
			<Row className='h-100'>
			<Col className='background-white-class'>
				<Row className='margin_Panel'></Row>
				<Row>
				<Col xs={14}>
					<div className='landing-logo-holder aligncenter'>
					<img src={sevenNowLogo} className='img-right-align' alt='SevenNow header Logo' />
					<h2 className='merchant-title1'> {MERCHANT_PORTAL_TEXT}</h2>
					</div>
					{userAccountList(true)}
				</Col>
				</Row>
			</Col>
			<Col style={{ backgroundColor: '#FAFAFA' }}>
				<Row className='margin_Panel'></Row>
				<Row>
				<Col xs={2}></Col>
				<Col xs={8}>
					<Card variant='outlined' className='cont-min-class'>
					<p className='create-text'>{CREATE_PASSWORD}</p>
					<CardContent>
						<form className='form-container' autoComplete='off' onSubmit={confirmPasswordReset}>
						<br />
						<TextField
							id='password'
							label='Password'
							onChange={handleChange}
							onPaste={handleChange}
							required
							variant='outlined'
							color='secondary'
							type='password'
							aria-label='Password'
							error={passwordError}
							helperText={formData.errors?.password}
							fullWidth
							sx={{ mb: 3 }}
							inputProps={{ fontSize: '26px' }}
							InputProps={{
							endAdornment: <InputAdornment position='end'>{formData.errors?.password ? <img src={passwordErrorIcon} className='error-icon' /> : null}</InputAdornment>,
							}}
						/>
						<TextField
							id='confirmpassword'
							label='Confirm Password'
							onChange={handleChange}
							onPaste={handleChange}
							required
							variant='outlined'
							color='secondary'
							type='password'
							aria-label='Confirm Password'
							error={confirmpasswordError}
							helperText={formData.errors?.confirmpassword}
							fullWidth
							sx={{ mb: 3 }}
							inputProps={{ fontSize: '26px' }}
							InputProps={{
							endAdornment: <InputAdornment position='end'>{formData.errors?.confirmpassword ? <img src={confirmpasswordErrorIcon} className='error-icon' /> : null}</InputAdornment>,
							}}
						/>
						<p className='login-terms'>
							{' '}
							{PRIVACY_POLICY_CONTENT.AGREE}{' '}
							<b className='termsandpolicy' onClick={privacyPolicyHandler}>
							{PRIVACY_POLICY_CONTENT.PRIVACY_POLICY_LABEL}
							</b>{' '}
							{PRIVACY_POLICY_CONTENT.AND}{' '}
							<b className='termsandpolicy' onClick={termsOfUseHandler}>
							{PRIVACY_POLICY_CONTENT.TERMS_OF_USE_LABEL}
							</b>
						</p>
						<button data-testid='updatePassword' className='form-container--primaryButton' aria-label='Submit Reset Password' disabled={!formValid} variant='outlined' type='submit'>
							{UPDATE_PASSWORD}
						</button>
						</form>
						{/* <button className='form-container--secondaryButton' aria-label='Cancel Reset Password'
						variant='outlined' onClick={cancelUserCreationHandler} type='button'>{CANCEL}</button> */}
						<br />
					</CardContent>
					<p className='adduser-terms'>{PASSWORD_MSG}</p>
					<div className='check-container'>
						<div className='check-item'>
						<img className='check-img' src={miniCharaCheckIcon} />
						<p className='check-text'>{PASSWORD_MIN}</p>
						</div>
						<div className='check-item'>
						<img className='check-img' src={specialCharaCheckIcon} />
						<p className='check-text'>{PASSWORD_CHAR}</p>
						</div>
						<div className='check-item'>
						<img className='check-img' src={containsNumberCheckIcon} />
						<p className='check-text'>{PASSWORD_NUMBER_REQ}</p>
						</div>
						<div className='check-item'>
						<img className='check-img' src={noRepCharaCheckIcon} />
						<p className='check-text'>{PASSWORD_REP}</p>
						</div>
					</div>
					</Card>
				</Col>
				<Col xs={2}></Col>
				</Row>
			</Col>
			</Row>
		</Container>

		{apiInProgress === true ? (
			<div className='loader-style'>
			<CircularProgress />
			</div>
		) : null}
		</>
	);
}
export default TempPassword;
